import React from "react";
import PropTypes from "prop-types";

function getProgramStatus(startDate, endDate) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const start = new Date(startDate);
    start.setHours(0, 0, 0, 0);

    const end = new Date(endDate);
    end.setHours(23, 59, 59, 999);

    if (today < start) {
        return "Upcoming";
    }

    if (today <= end) {
        return "In Progress";
    }

    return "Completed";
}

function ProgramCard({ program }) {

    const {
    title,
    startDate,
    endDate,
    description,
    date,
    time,
    ageGroup,
    price,
    location,
    locationUrl,
    registrationUrl,
    registrationText = "Click Here to Register Now"
} = program;

const status = getProgramStatus(startDate, endDate);

function getStatusClass(status) {
  switch (status.toLowerCase()) {
    case "in progress":
      return "text-bg-success";

    case "upcoming":
      return "text-bg-primary";

    case "registration open":
      return "text-bg-info";

    case "limited spots":
      return "text-bg-warning";

    case "sold out":
      return "text-bg-danger";

    case "completed":
      return "text-bg-secondary";

    default:
      return "text-bg-secondary";
  }
}

    return (

        <article className="program-card">
            <div className="program-card__header">
                <h2 className="program-card__title">
                  {title}
                </h2>
                {status && (
                  <span
                    className={`badge rounded-pill ${getStatusClass(status)} program-card__status`}
                  >
                    {status}
                  </span>
                )}
            </div>

            <p className="program-card__description">
                {description}
            </p>

            <div className="program-card__details">

                <div className="program-card__detail">

                    <div className="program-card__detail-heading">
                        <i className="bi bi-calendar3"></i>
                        <span>Date</span>
                    </div>

                    <div className="program-card__detail-value">
                        {date}
                    </div>

                </div>

                <div className="program-card__detail">

                    <div className="program-card__detail-heading">
                        <i className="bi bi-clock"></i>
                        <span>Time</span>
                    </div>

                    <div className="program-card__detail-value">
                        {time}
                    </div>

                </div>

                <div className="program-card__detail">

                    <div className="program-card__detail-heading">
                        <i className="bi bi-people-fill"></i>
                        <span>Age Group</span>
                    </div>

                    <div className="program-card__detail-value">
                        {ageGroup}
                    </div>

                </div>

                <div className="program-card__detail">

                    <div className="program-card__detail-heading">
                        <i className="bi bi-currency-dollar"></i>
                        <span>Price</span>
                    </div>

                    <div className="program-card__detail-value">
                        {price}
                    </div>

                </div>

            </div>

            <div className="program-card__location">

                <div className="program-card__detail-heading">
                    <i className="bi bi-geo-alt-fill"></i>
                    <span>Location</span>
                </div>

                <a
                    href={locationUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="program-card__location-link"
                >
                    {location}
                </a>

            </div>

            <a
                href={registrationUrl}
                className="program-card__register-button"
            >
                {registrationText}
            </a>

        </article>

    );

}

ProgramCard.propTypes = {
    program: PropTypes.shape({
        id: PropTypes.number,
        title: PropTypes.string.isRequired,
        status: PropTypes.string,
        description: PropTypes.string,
        date: PropTypes.string,
        time: PropTypes.string,
        ageGroup: PropTypes.string,
        price: PropTypes.string,
        location: PropTypes.string,
        locationUrl: PropTypes.string,
        registrationUrl: PropTypes.string,
        registrationText: PropTypes.string
    }).isRequired
};

export default ProgramCard;